const poll = async ({ fn, validate, interval, maxAttempts }) => {
  let attempts = 0

  const executePoll = async (resolve, reject) => {
    try {
      const result = await fn()
      attempts++
      if (validate(result)) {
        return resolve(result)
      } else if (maxAttempts && attempts === maxAttempts) {
        return reject(new Error('Exceeded max attempts'))
      } else {
        setTimeout(executePoll, interval, resolve, reject)
      }
    } catch (err) {
      reject(err)
    }
  }

  return new Promise(executePoll)
}

export default poll
